import React from 'react';
import CustomPopup from './custom-popup';
//import SubscriptionPopup from './subscription-popup';

const PopupContentWrapper = ({ children }) => (
  <>
    {children}
    {/* <SubscriptionPopup /> */}
    <CustomPopup />
  </>
);

export default PopupContentWrapper;